import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import courseActions from '@redux/course/actions';
import { CreateCourseDiscussionRequestAction } from '@redux/course/type/courseDetailType';
import { RootState } from '@redux/reducer';

type UseCreateCourseDiscussionListProps = {
  idName?: string;
};

export type CreateCourseDiscussionPayload = Omit<CreateCourseDiscussionRequestAction, 'courseIdOrIdName'>;

const { createCourseDiscussionAction } = courseActions;

export const useCreateCourseDiscussion = ({ idName }: UseCreateCourseDiscussionListProps) => {
  const dispatch = useDispatch();

  const { createCourseDiscussionState } = useSelector((state: RootState) => ({
    createCourseDiscussionState: state.Course.get('createCourseDiscussionState'),
  }));

  const handleCreateCourseDiscussion = useCallback(
    (payload: CreateCourseDiscussionPayload) => {
      if (!idName) {
        return;
      }
      dispatch(
        createCourseDiscussionAction.request({
          courseIdOrIdName: idName,
          title: payload.title,
        }),
      );
    },
    [dispatch, idName],
  );

  const handleResetCreateCourseDiscussion = () => {
    dispatch(createCourseDiscussionAction.reset());
  };

  const {
    data: createCourseDiscussionData,
    error: createCourseDiscussionDataError,
    isLoading: isCreateCourseDiscussionDataLoading,
    isError: isCreateCourseDiscussionDataError,
    isSuccess: isCreateCourseDiscussionDataSuccess,
  } = createCourseDiscussionState;

  return {
    handleCreateCourseDiscussion,
    createCourseDiscussionData,
    createCourseDiscussionDataError,
    isCreateCourseDiscussionDataLoading,
    isCreateCourseDiscussionDataError,
    isCreateCourseDiscussionDataSuccess,
    handleResetCreateCourseDiscussion,
  };
};
